export default __webpack_public_path__ + "dist/media/Mobile.5be77a8d.svg";